export type PropertyOf<T> = {
    [P in keyof T]?: any
};

function _isType(val: any, typeName: string): boolean {
    return val !== undefined && val !== null && val.constructor && val.constructor.name === typeName;
}

// tslint:disable-next-line:variable-name
export class ObjectHelper {

    public static assign<T>(target: T, ...sources: (T | PropertyOf<T>)[]): T {
        if (target && sources)
            for (const source of sources)
                for (const prop of Object.keys(source))
                    if (target.hasOwnProperty(prop))
                        target[prop] = source[prop];

        return target;
    }

    public static isEmpty(val: any): boolean {
        return ObjectHelper.isObject(val) && Object.keys(val).length === 0;
    }

    public static isArray(val: any): boolean {
        return _isType(val, 'Array');
    }

    public static isNumber(val: any): boolean {
        return _isType(val, 'Number');
    }

    public static isString(val: any): boolean {
        return _isType(val, 'String');
    }

    public static isDate(val: any): boolean {
        return _isType(val, 'Date');
    }

    public static isBoolean(val: any): boolean {
        return _isType(val, 'Boolean');
    }

    public static isObjectEmpty(val: any): boolean {
        for (const key in val) {
            if (val.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    public static isObject(val: any): boolean {
        return _isType(val, 'Object');
    }

    public static isEquals(x: any, y: any): boolean {
        if (x === y) return true;

        if (!(x instanceof Object) || !(y instanceof Object)) return false;

        if (x.constructor !== y.constructor) return false;

        for (const p in x) {
            if (!x.hasOwnProperty(p)) continue;

            if (!y.hasOwnProperty(p)) return false;

            if (x[p] === y[p]) continue;

            if (typeof (x[p]) !== 'object') return false;

            if (!ObjectHelper.isEquals(x[p], y[p])) return false;
        }

        for (const p in y) {
            if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
        }
        return true;
    }
}
